import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 3],
      rowsSize: [1, 4, 4],
      rowSpan: {
        "1:1": 2,
      },
      colSpan: {
        "0:0": 2,
      },
      gap: "17px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data: "Data Acquisition and Generation: Powertrain",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-end",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/4-thumb-receiver.png`,
                  styles: {
                    maxHeight: "225px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/4-receiver.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "For a realistic simulation of vehicle sound a detailed characterization of different sound sources, including their behavior and strength at different operating points, is required. In practice, this is achieved through the process of transfer path analysis (TPA), which separates and quantifies the contributions of relevant sound sources along different paths (e.g. air-borne or structure-borne) by means of adequate source-receiver sensor configurations. For best results a binaural TPA should be done utilizing an artificial head as a receiver.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
